// extracted by mini-css-extract-plugin
export default {"filebox":"BoardThumb_filebox__00ejf","upload-name":"BoardThumb_upload-name__0Wady"};